<template>
  <div id="warningTimeout" class="modal fade" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content first-modal-content">
        <div class="modal-header warningTimeout-bgcolor">
          <div class="modal-title">
            <div class="title-text">Session Timeout</div>
          </div>
        </div>
        <div class="modal-body">
          <div class="sub-header pt-11">
            <span>Your session is about to expire in <br /></span>
            <span class=""
              ><strong>&nbsp;&nbsp;{{ gettime }} seconds</strong> due to inactivity.</span
            >
          </div>
          <div class="sub-header pt-35">Do you want to stay logged in?</div>
        </div>
        <div class="modal-footer warningTimeout-bgcolor">
          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 mt-10">
            <button class="btn btn-block emergo-white-button" @click="loadLogOut">Log Out</button>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 mt-10">
            <button
              class="btn btn-block emergo-green-button"
              data-dismiss="modal"
              @click="loadAgain"
              data-toggle="tab"
              data-target="#warningTimeout"
            >
              Stay Connected
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';

export default {
  props: {},
  data() {
    return {
      gettime: 30,
      warningOut: 1
    };
  },

  methods: {
    makeTimeOut() {
      this.gettime = 30;
      clearInterval(this.warningOut);
      this.warningOut = setInterval(this.warningTime, 1000);
    },
    warningTime() {
      if (this.gettime > 0) {
        this.gettime -= 1;
      }
      if (this.gettime === 0) {
        clearInterval(this.warningOut);
        this.warningOut = undefined;
        groove.widget.close();
        this.loadLogOut();
      }
    },

    loadLogOut() {
      socket.removeAllListeners(
        `alertSaveMultiRegistrationDetails_${localStorage.getItem('userId')}`
      );
      document.cookie = 'Authorization=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
      document.cookie = 'redirect_url=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
      localStorage.clear();
      sessionStorage.clear();
      groove.widget.close();
      this.$router.push('/login');
    },
    loadAgain() {
      clearInterval(this.warningOut);
      this.warningOut = undefined;
      localStorage.setItem('removeIdlePopups', true);
    }
  },
  mounted() {
    $('#warningTimeout').on('show.bs.modal', this.makeTimeOut);
    $('#warningTimeout').on('hidden.bs.modal', () => {
      clearInterval(this.warningOut);
      this.warningOut = undefined;
      $('.modal-backdrop').remove();
    });
  },
  beforeDestroy() {
    clearInterval(this.warningOut);
  }
};
</script>
<style lang="scss" scoped>
.modal-header {
  &.warningTimeout-bgcolor {
    background-color: $deep-white;
    border: 0px;
    border-radius: $radius10;
  }
}
.modal-footer {
  &.warningTimeout-bgcolor {
    background-color: $deep-white;
    border: 0px;
    border-radius: $radius10;
    padding-top: 5px;
    padding-bottom: 32px;
  }
}
.modal-content {
  &.first-modal-content {
    border-radius: 12px;
  }
}
.modal-title {
  .title-text {
    text-align: center;
    color: #cf5f28;
    padding-top: 15px;
    font-weight: $font-weight-medium;
    font-size: $font-32;
    line-height: 37px;
  }
}
.modal-body {
  .sub-header {
    color: $dark-black-alpha;
    font-style: normal;
    @include fontItems($font-24, 28px, $font-weight-normal);
    text-align: center;
  }
}
.pt-11 {
  padding-top: 11px;
}
.pt-35 {
  padding-top: 35px;
}
@media (min-width: 768px) and (max-width: 1024px) {
  .modal-dialog {
    vertical-align: top;
    margin-top: 200px;
  }
}
@media only screen and (max-width: 410px) {
  .modal-body {
    .sub-header {
      font-size: $font-22;
    }
  }
}
</style>
